import React, { Component } from 'react';
import App_data from '../config/App_data';
import FD from '../RestAPI/fetchData';
import language from '../../assets/languages/language';
import { renderHTMLContent } from '../../common/function';
/* eslint-disable*/

class Addons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      exams: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      answered: [],
      plan_data: '',
      pack_class: 'hide_block',
      exam_name: '',
      exam_class: 'row',
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to Add Addon to cart and push routing to cart page
  _buyPackage = (item, e) => {
    var data = { token: this.state.token, idname: this.state.idname, plan_id: item.id };
    FD.callAPI(App_data.backend_api + '/checkout/addExamsToCart', data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.context.router.push({
          pathname: '/cart/',
          state: {
            token: this.state.token,
            idname: this.state.idname,
            package_data: item,
            exam_name: this.state.exam_name,
          },
        });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  //Function to redirect page to subscription page
  _getExams = (item, e) => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    //Fetch all Addons
    FD.callAPI(App_data.backend_api + '/checkout/getAddons', data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        if (resp.exam_plans.length) {
          var plan_data = resp.exam_plans.map((item) => (
            <div className='col-md-4 align-self-center text-center'>
              <div className='plan_wrapper'>
                <div className='plan_header'>
                  {language.LC().ALL_EXAMS}
                  {/*{item.name}*/}
                </div>
                <div className='plan_price'>${item.price}</div>
                {renderHTMLContent(item.package_desc, "div", "addon_text")}
                <button
                  type='button'
                  className='btn btn-primary pointer_class margin_bottom_40'
                  onClick={this._buyPackage.bind(this, item)}
                >
                  {language.LC().BUY}
                </button>
                {/*<div className="plan_btn_wrap">
                        <div className="plan_button">
                        </div>
                    </div>*/}
              </div>
            </div>
          ));
        } else {
          var plan_data = <div>{language.LC().NO_PACKAGE_FOUND}</div>;
        }
        this.setState({ package_data: plan_data });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  render() {
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{language.LC().ADDONS}</h1>
          </div>
          <div className='col-md-4 text-md-right margin_bottom_20'>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getExams.bind(this)}
            >
              {language.LC().GO_BACK_TO_EXAMS}
            </button>
          </div>
        </div>
        <div className='row'>{this.state.package_data}</div>
      </div>
    );
  }
}

export default Addons;



// WEBPACK FOOTER //
// ./src/views/Addons/Addons.js